import React from 'react';
import { MinusIcon, PlusIcon } from 'lucide-react';
interface QuantityStepperProps {
  value: number;
  onChange: (next: number) => void;
  max?: number;
  label?: string;
  className?: string;
}

/**
 * Pack quantity control used inside every pack card. Some customers want two or
 * three of the same pack, so the count lives with the pack instead of in a
 * separate builder they have to hunt for.
 */
export function QuantityStepper({
  value,
  onChange,
  max = 20,
  label = 'Pack quantity',
  className = ''
}: QuantityStepperProps) {
  const set = (next: number) => onChange(Math.min(max, Math.max(1, next)));
  return <div className={`flex items-center gap-3 ${className}`} data-id="element-776" data-mp="2qll7x227tg6q">
      <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-steel-400" data-id="element-777" data-mp="2lo32vmrbjl40">How many</p>
      <div className="flex items-center border-2 border-white/20" data-id="element-778" data-mp="30ku5e4wahcxu">
        <button type="button" onClick={() => set(value - 1)} disabled={value <= 1} aria-label={`Decrease ${label}`} className="flex h-11 w-11 items-center justify-center text-offwhite transition-colors duration-150 ease-grit hover:bg-white/10 disabled:opacity-30 disabled:hover:bg-transparent" data-id="element-779" data-mp="30iznz0k882yi">
          <MinusIcon className="h-4 w-4" aria-hidden="true" data-id="element-780" data-mp="2vmils3wsypyn" />
        </button>
        <input type="number" min={1} max={max} value={value} onChange={event => set(Number(event.target.value) || 1)} aria-label={label} className="h-11 w-14 border-x-2 border-white/20 bg-transparent text-center font-display text-2xl font-extrabold text-offwhite [appearance:textfield] focus:outline-none focus-visible:bg-white/5 [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none" data-id="element-781" data-mp="30n6c0nd7j2rt" />
        <button type="button" onClick={() => set(value + 1)} disabled={value >= max} aria-label={`Increase ${label}`} className="flex h-11 w-11 items-center justify-center text-offwhite transition-colors duration-150 ease-grit hover:bg-white/10 disabled:opacity-30 disabled:hover:bg-transparent" data-id="element-782" data-mp="3od0mwzdyuh9f">
          <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-783" data-mp="1o7wutqvhp608" />
        </button>
      </div>
    </div>;
}
export const money = (value: number) => `$${value.toLocaleString('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})}`;